import { environment } from '../environments/environment';

const baseApiUrl = environment.apiGatewayUrl + environment.baseUrl;
const BUILD_TIMESTAMP_HEADER = 'X-Build-Timestamp';

export const fetchAsync = async <T>(url: string) => {
  const response = await fetch(baseApiUrl + url, {
    headers: {
      [BUILD_TIMESTAMP_HEADER]: (window as any).BUILD_TIMESTAMP,
    },
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  const result = await response.json();
  return result as T;
};

export const postAsync = async <TRequest, TResponse>(url: string, body: TRequest): Promise<TResponse> => {
  const headers = new Headers();
  headers.set('Content-Type', 'application/json');
  headers.set(BUILD_TIMESTAMP_HEADER, (window as any).BUILD_TIMESTAMP);
  const response = await fetch(baseApiUrl + url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers,
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  const result = await response.json();
  return result as TResponse;
};
